import img1 from '../images/recent/image1.jpg'
import img2 from '../images/recent/image2.jpg'
import img3 from '../images/recent/image3.jpg'
import img4 from '../images/recent/image4.jpg'


export const sliderData = [
  {
    id: 1,
    image: img1,
    title: 'Small details',
    settings: '100mm f/2.8 1/160s ISO100',
    alignment: 'horizontal' ,
    alt: 'macro plant'
  },
  {
    id: 2,
    image: img2,
    title: 'Sunrise magic',
    settings: '16mm f/14 0.4s ISO125',
    alignment: 'horizontal',
    alt: 'sunrise colors'
  },
  {
    id: 3,
    image: img3,
    title: 'Sunrise pond',
    settings: '16mm f/14 1/320s ISO100',
    alignment: 'horizontal',
    alt: 'sunrise rays'
  },
  {
    id: 4,
    image: img4,
    title: 'Red beauty',
    settings: '100mm f/4.5 1/100s ISO320',
    alignment: 'horizontal',
    alt: 'flower field'
  }
]